var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaLegendA3It(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a3",
    width: 1587.402,
    height: "297mm",
    viewBox: "0 0 1190.551 841.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "rect2",
    d: "M0 0h1190.551v841.89H0z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "rand",
    transform: "translate(1.85 .207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1034",
    d: "M74.627 788.31h662.082c1.3 0 2.353 1.224 2.353 2.735v25.487c0 1.51-1.053 2.736-2.353 2.736H74.627Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text503",
    x: 77.825,
    y: 814.526,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan7656",
    x: 77.825,
    y: 814.526
  }, "Fonte: OpenStreetMap contributors \xA9 SBB/CFF/FFS www.tra\uFB01mage.ch www.geops.ch"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text105827",
    x: 78.083,
    y: 798.215,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      lineHeight: 1,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan7630",
    x: 78.083,
    y: 798.215
  }, "Per determinate linee di autobus \xE8 necessario acquistare un supplemento e/o una prenotazione del posto. Attenzione: dal 21 marzo al 31 ottobre, nei treni InterCity (IC) \xE8 inoltre obbligatoria la prenotazione del posto per le biciclette. Le indicazioni")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan7632",
    x: 78.083,
    y: 804.215
  }, "per il collegamento desiderato sono riportarte nell\u2019orario (online). Per mancanza di spazio, a seconda del livello di zoom, non vi figurano tutte le linee. Tutte le informazioni non sono garantite. Salvo modifiche. Si applica il campi d&apos;applicazione.")))), /*#__PURE__*/React.createElement("g", {
    id: "qr-code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect23865",
    d: "M22.453 768.451h51.024v51.024H22.453Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7664",
    d: "M23.91 769.91h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.46zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458H37.03zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H50.15zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H63.27zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0H69.1v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm-46.649 1.458h1.458v1.458H23.91Zm8.747 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H37.03zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm5.832 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458zm8.747 0h1.458v1.458h-1.458Zm-46.649 1.458h1.458v1.457H23.91Zm2.916 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm1.458 0H31.2v1.457h-1.46zm2.916 0h1.458v1.457h-1.458zm4.373 0h1.458v1.457H37.03zm4.373 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457zm4.373 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm2.915 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458Zm1.458 0h1.458v1.457h-1.458zm1.458 0H69.1v1.457h-1.457zm2.915 0h1.458v1.457h-1.458Zm-46.649 1.457h1.458v1.458H23.91Zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.46zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.458zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0H69.1v1.458h-1.457zm2.915 0h1.458v1.458h-1.458Zm-46.649 1.458h1.458v1.458H23.91Zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.46zm2.916 0h1.458v1.458h-1.458zm7.289 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H50.15zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0H69.1v1.458h-1.457zm2.915 0h1.458v1.458h-1.458ZM23.91 777.2h1.458v1.458H23.91Zm8.747 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H37.03zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm5.832 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm8.747 0h1.458v1.458h-1.458Zm-46.649 1.458h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.46zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458H50.15zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H63.27zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0H69.1v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-33.529 1.458h1.458v1.457H37.03zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm4.373 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457H50.15zm1.458 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457Zm-30.614 1.457h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.46zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.458zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458H63.27zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm-42.275 1.458h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.46zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm5.83 0h1.458v1.458h-1.457zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458H50.15zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H63.27zm4.374 0H69.1v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm-46.649 1.458h1.458v1.458H23.91Zm4.373 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H37.03zm1.458 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458H50.15zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H63.27zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm-42.275 1.458h1.457v1.457h-1.457zm7.289 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H37.03zm2.916 0h1.457v1.457h-1.457zm4.373 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm8.747 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm4.373 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H63.27zm4.374 0H69.1v1.457h-1.457Zm-43.734 1.457h1.458v1.458H23.91Zm5.831 0H31.2v1.458h-1.46zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H37.03zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458H63.27zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm-40.818 1.458h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm8.747 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H50.15zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.458zm1.457 0h1.458v1.458h-1.458ZM23.91 790.32h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0H31.2v1.458h-1.46zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.458zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm7.289 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm8.746 0h1.458v1.458H63.27zm1.458 0h1.458v1.458h-1.458Zm4.373 0h1.458v1.458h-1.458zm-42.275 1.458h1.457v1.458h-1.457zm7.289 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm10.205 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H63.27zm4.374 0H69.1v1.458h-1.457zm-34.987 1.458h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H37.03zm4.373 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm5.831 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457H63.27zm1.458 0h1.458v1.457h-1.458Zm4.373 0h1.458v1.457h-1.458Zm-45.191 1.457h1.458v1.458H23.91Zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.46zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm5.83 0h1.458v1.458h-1.457zm7.29 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458H50.15zm1.458 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-45.191 1.458h1.458v1.458h-1.458zm4.373 0H31.2v1.458h-1.46zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm10.205 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm5.83 0h1.459v1.458h-1.458zm1.459 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458Zm-45.191 1.458h1.458v1.458H23.91Zm2.916 0h1.457v1.458h-1.457zm7.289 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm8.747 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm5.83 0h1.459v1.458h-1.458zm1.459 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458H63.27zm4.374 0H69.1v1.458h-1.457Zm-43.734 1.458h1.458v1.458H23.91Zm2.916 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458Zm4.373 0h1.458v1.458h-1.458Zm-45.191 1.458h1.458v1.457H23.91Zm2.916 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H37.03zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm5.831 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H50.15zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm4.373 0h1.458v1.457h-1.458zm4.373 0h1.458v1.457h-1.458zm4.374 0h1.458v1.457h-1.458zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458ZM23.91 801.98h1.458v1.458H23.91Zm4.373 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.458zm4.373 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H63.27zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458Zm-45.191 1.46h1.458v1.458H23.91Zm2.916 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm7.288 0h1.458v1.458h-1.458zm5.832 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458H50.15zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0H69.1v1.458h-1.457Zm-43.734 1.458h1.458v1.458H23.91Zm2.916 0h1.457v1.458h-1.457zm2.915 0H31.2v1.458h-1.46zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H63.27zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm-34.987 1.458h1.458v1.457h-1.458zm1.458 0h1.458v1.457H37.03zm2.916 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm4.374 0h1.457v1.457h-1.457zm4.373 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm4.373 0h1.458v1.457h-1.458zm5.831 0h1.458v1.457h-1.458Zm1.458 0h1.458v1.457h-1.458zm1.458 0H69.1v1.457h-1.457zm2.915 0h1.458v1.457h-1.458Zm-46.649 1.457h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.46zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm8.746 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458ZM23.91 809.27h1.458v1.458H23.91Zm8.747 0h1.458v1.458h-1.458zm11.662 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458H50.15zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0H69.1v1.458h-1.457zm2.915 0h1.458v1.458h-1.458Zm-46.649 1.458h1.458v1.458H23.91Zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.46zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H37.03zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H63.27zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm-46.649 1.458h1.458v1.458H23.91Zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.46zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H37.03zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm7.289 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H50.15zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458H63.27zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0H69.1v1.458h-1.457Zm-43.734 1.458h1.458v1.457H23.91Zm2.916 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm1.458 0H31.2v1.457h-1.46zm2.916 0h1.458v1.457h-1.458zm2.915 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm5.831 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457H50.15zm2.916 0h1.458v1.457h-1.458zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H63.27zm2.916 0h1.458v1.457h-1.458zm2.915 0h1.458v1.457h-1.458ZM23.91 815.1h1.458v1.458H23.91Zm8.747 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H37.03zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm5.832 0h1.457v1.458h-1.457zm5.83 0h1.459v1.458h-1.458zm1.459 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0H69.1v1.458h-1.457Zm-43.734 1.46h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.46zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H37.03zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H50.15zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm5.83 0h1.459v1.458h-1.458zm2.916 0h1.458v1.458h-1.458z",
    style: {
      fill: "#000",
      strokeWidth: 0.208256
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "sbb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect22814",
    d: "M971.83 22.677h196.044v22.94H971.83z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect397399",
    d: "M973.281 23.927h192.107v20.659H973.281z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2879",
    d: "M973.28 44.374h60.703V24.139h-60.702v20.235Z",
    style: {
      fill: "#e42328",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2881",
    d: "M1009.012 32.708h6.564v-5.196h3.091v5.196h6.563l-5.28-5.196h3.918l6.745 6.745-6.745 6.744h-3.92l5.28-5.196h-6.56v5.196h-3.093v-5.196h-6.563l5.28 5.196h-3.916l-6.744-6.744 6.744-6.745h3.917",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2883",
    d: "M1040.247 36.972c-.039 3.492 2.896 5.04 6.03 5.04 3.848 0 5.891-1.944 5.891-4.543 0-3.212-3.173-3.867-4.205-4.123-3.55-.913-4.224-1.052-4.224-2.142 0-1.19 1.15-1.606 2.143-1.606 1.488 0 2.698.435 2.796 2.143h3.015c0-3.273-2.717-4.561-5.672-4.561-2.559 0-5.296 1.388-5.296 4.285 0 2.658 2.122 3.471 4.226 4.026 2.082.554 4.203.813 4.203 2.339 0 1.448-1.666 1.766-2.757 1.766-1.666 0-3.133-.735-3.133-2.62",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2885",
    d: "M1057.203 29.933h2.915c1.11 0 2.143.277 2.143 1.626 0 1.19-.814 1.686-1.904 1.686h-3.154v-3.312Zm-3.113 11.741h6.861c2.559 0 5-1.23 5-4.106 0-1.764-.875-3.094-2.6-3.59a3.106 3.106 0 0 0 1.926-2.956c0-2.637-1.826-3.51-4.524-3.51h-6.663v14.162Zm3.113-6.307h3.39c1.329 0 2.241.576 2.241 2.023 0 1.467-1.07 1.865-2.3 1.865h-3.33",
    style: {
      fill: "#221e20",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2887",
    d: "M1071.14 29.933h2.916c1.11 0 2.142.277 2.142 1.626 0 1.19-.813 1.686-1.904 1.686h-3.154v-3.312Zm-3.113 11.741h6.861c2.56 0 4.998-1.23 4.998-4.106 0-1.764-.872-3.094-2.598-3.59a3.106 3.106 0 0 0 1.924-2.956c0-2.637-1.824-3.51-4.522-3.51h-6.663v14.162Zm3.115-6.307h3.39c1.33 0 2.242.576 2.242 2.023 0 1.467-1.07 1.865-2.3 1.865h-3.331",
    style: {
      fill: "#221e20",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2889",
    d: "M1099.666 32.272c-.377-3.272-2.994-5.096-6.108-5.096-4.384 0-6.96 3.273-6.96 7.477 0 4.086 2.576 7.358 6.96 7.358 3.471 0 5.91-2.26 6.227-5.792h-3.016c-.237 1.865-1.308 3.173-3.211 3.173-2.796 0-3.849-2.38-3.849-4.74 0-2.479 1.053-4.86 3.849-4.86 1.546 0 2.896 1.071 3.094 2.479",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2891",
    d: "M1101.702 41.674h3.114v-5.851h5.93v-2.42h-5.93v-3.272h6.842v-2.617h-9.956",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2893",
    d: "M1113.551 41.674h3.105v-5.851h5.924v-2.42h-5.926v-3.272h6.835v-2.617h-9.938",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2895",
    d: "M1130.233 41.674h3.122v-5.851h5.924v-2.42h-5.924v-3.272h6.834v-2.617h-9.955",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2897",
    d: "M1142.457 41.674h3.104v-5.851h5.924v-2.42h-5.924v-3.272h6.852v-2.617h-9.957",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2899",
    d: "M1153.554 36.972c-.035 3.492 2.89 5.04 6.031 5.04 3.854 0 5.889-1.944 5.889-4.543 0-3.212-3.177-3.867-4.194-4.123-3.55-.913-4.228-1.052-4.228-2.142 0-1.19 1.141-1.606 2.142-1.606 1.48 0 2.695.435 2.801 2.143h2.998c0-3.273-2.712-4.561-5.656-4.561-2.57 0-5.3 1.388-5.3 4.285 0 2.658 2.124 3.471 4.23 4.026 2.07.554 4.193.813 4.193 2.339 0 1.448-1.66 1.766-2.748 1.766-1.678 0-3.14-.735-3.14-2.62",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "title"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path523",
    d: "M-.224 22.677h522.825c1.254 0 2.272 1.346 2.272 3.004v95.824c0 1.657-1.018 3.004-2.273 3.004H-.224Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text745",
    x: 22.102,
    y: 48.444,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 18,
      fontFamily: "SBBWeb-Light,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan450",
    x: 22.102,
    y: 48.444
  }, "Abbonamento generale, AG Night, carta mensile AG, carta")), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan452",
    x: 22.102,
    y: 70.944
  }, "giornaliera per il met\xE0-prezzo e carta giornaliera risparmio /")), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan454",
    x: 22.102,
    y: 93.444
  }, "carta giornaliera promo / carta giornaliera risparmio Comune")), _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan456",
    x: 22.102,
    y: 115.944
  }, "con abbonamento met\xE0-prezzo valido")))), /*#__PURE__*/React.createElement("g", {
    id: "legend",
    transform: "translate(0 15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect426128-0-8-3-9-2",
    width: 196.237,
    height: 131.095,
    x: 15.117,
    y: 117.193,
    rx: 2.551,
    ry: 2.551,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "scaleline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2491",
    d: "M22.815 226.519h135.509v13.898H22.815Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "text2343",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text756",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(88.55 236.294)"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan750",
    x: 0,
    y: 0
  }, "50")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan752",
    x: 9.731,
    y: 0,
    style: {
      letterSpacing: ".00342em"
    }
  }, "k"), _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan754",
    x: 13.388,
    y: 0
  }, "m")))), /*#__PURE__*/React.createElement("path", {
    id: "path1881",
    d: "M175.435 226.52v13.371l-152.168.074V226.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".9031px",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g777"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text763",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(22.21 158.543)"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan7548",
    x: 0,
    y: 0
  }, "Ferrovie"))), /*#__PURE__*/React.createElement("g", {
    id: "g775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line765",
    d: "M23.628 142.724h32.28",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line767",
    d: "M23.628 147.113v0",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line769",
    d: "M26.563 147.113H54.44",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.93449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line771",
    d: "M55.908 147.113v0",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g795"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text781",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(121.817 158.665)"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1122",
    x: 0,
    y: 0
  }, "Trasporti a")), _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1124",
    x: 0,
    y: 8.75
  }, "fune"))), /*#__PURE__*/React.createElement("g", {
    id: "g793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line783",
    d: "M122.891 142.724h32.279",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line785",
    d: "M122.891 147.113v0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line787",
    d: "M125.825 147.113h27.878",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.93449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line789",
    d: "M155.17 147.113v0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9-7-1",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text809",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(171.621 196.83)"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan7520",
    x: 0,
    y: 0
  }, "Chiedere la")), _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan7522",
    x: 0,
    y: 8.75
  }, "validit\xE0 in")), _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan7524",
    x: 0,
    y: 17.5
  }, "loco")))), /*#__PURE__*/React.createElement("g", {
    id: "g836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line830",
    d: "M172.523 185.415v0",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line832",
    d: "M175.457 185.415h27.878",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.93449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line834",
    d: "M204.802 185.415v0",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g866"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text852",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(171.621 158.665)"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1144",
    x: 0,
    y: 0
  }, "Batelli"))), /*#__PURE__*/React.createElement("g", {
    id: "g864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line854",
    d: "M172.523 142.724h32.279",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line856",
    d: "M172.523 147.113v0",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line858",
    d: "M175.457 147.113h27.878",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.93449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line860",
    d: "M204.802 147.113v0",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g904"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text880",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(72.072 158.652)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan868",
    x: 0,
    y: 0,
    style: {
      letterSpacing: "-.00586em"
    }
  }, "A"), _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan870",
    x: 4.495,
    y: 0
  }, "u")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan872",
    x: 8.388,
    y: 0,
    style: {
      letterSpacing: "-.02246em"
    }
  }, "t"), _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan874",
    x: 10.435,
    y: 0
  }, "obu")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan876",
    x: 22.497,
    y: 0,
    style: {
      letterSpacing: ".00488em"
    }
  }, "s")), /*#__PURE__*/React.createElement("g", {
    id: "g902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line882",
    d: "M73.547 142.724h31.707",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g890"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line884",
    d: "M73.26 147.113v0",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line886",
    d: "M76.194 147.113h27.878",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.93449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line888",
    d: "M105.539 147.113v0",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line892",
    d: "M73.26 142.724h32.279",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line894",
    d: "M73.26 147.113v0",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line896",
    d: "M76.194 147.113h27.878",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.93449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line898",
    d: "M105.539 147.113v0",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text920",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(22.21 196.83)"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1164",
    x: 0,
    y: 0
  }, "Libera")), _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1166",
    x: 0,
    y: 8.75
  }, "circolazione")))), /*#__PURE__*/React.createElement("g", {
    id: "g935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line923",
    d: "M23.485 172.15h32.279",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line925",
    d: "M23.485 180.994h32.279",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line927",
    d: "M23.486 185.415h32.279",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line929",
    d: "M23.772 176.572h31.707",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line931",
    d: "M23.485 176.572h32.279",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1019"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text975",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(72.014 196.83)"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1278",
    x: 0,
    y: 0
  }, "Viaggi a")), _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1280",
    x: 0,
    y: 8.75
  }, "prezzo")), _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1282",
    x: 0,
    y: 17.5
  }, "ridotto"))), /*#__PURE__*/React.createElement("g", {
    id: "g983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line977",
    d: "M73.261 172.15v0",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line979",
    d: "M76.195 172.15h27.878",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.93449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line981",
    d: "M105.54 172.15v0",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line985",
    d: "M73.261 180.994v0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line987",
    d: "M76.195 180.994h27.878",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.93449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line989",
    d: "M105.54 180.994v0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line993",
    d: "M73.261 185.415v0",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line995",
    d: "M76.195 185.415h27.878",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.93449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line997",
    d: "M105.54 185.415v0",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line1001",
    d: "M73.261 176.572v0",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line1003",
    d: "M76.195 176.572h27.878",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.93449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line1005",
    d: "M105.54 176.572v0",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line1009",
    d: "M73.261 176.572v0",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line1011",
    d: "M76.195 176.572h27.878",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.93449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line1013",
    d: "M105.54 176.572v0",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9-7",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1043",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(121.818 196.83)"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan3230",
    x: 0,
    y: 0
  }, "Nessuna")), _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan3232",
    x: 0,
    y: 8.75
  }, "riduzione")))), /*#__PURE__*/React.createElement("path", {
    id: "line1046",
    d: "M122.891 185.415h32.28",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "state-publisher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text2350",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1052",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(51.046 128.648)"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1050",
    x: 0,
    y: 0
  }, "***publishedAt***")))), /*#__PURE__*/React.createElement("g", {
    id: "text2347",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1057",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(22.21 128.648)"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1102",
    x: 0,
    y: 0
  }, "Creato il")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaLegendA3It);
export default __webpack_public_path__ + "static/media/ga_legend_a3_it.465aa6e530c013036549b024bcb3f62c.svg";
export { ForwardRef as ReactComponent };